import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const pdfCreateSlice = createApi({
    reducerPath: "pdfCreate",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://pbp.policy-parser.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        pdfCreate: builder.mutation({
            query: (data) => ({ url: "/api/v1/pdf/create", method: "POST", body: data }),
        }),
    }),
});

export const { usePdfCreateMutation } = pdfCreateSlice;
